import React from 'react';

import Loading from 'components/Loading';
import { useGetBudgetProposal } from '../hooks/budgetProposal';
import {
    CurrentBudgetProposalContext,
    isLegitBudgetProposal,
} from 'routes/BudgetModule/components/BudgetProposal/Resource/contexts/CurrentBudgetProposalContext';

type Props = {
    budgetProposalId: number;
    children: React.ReactNode;
};

const CurrentBudgetProposalProvider = ({
    budgetProposalId,
    children,
}: Props): React.ReactElement => {
    const { isLoading, data: budgetProposal } = useGetBudgetProposal({
        budgetProposalId,
    });
    // TODO: it's probably an anti-pattern to return loading component here, it should return null and let the parent handle the loading state
    if (isLoading || !isLegitBudgetProposal(budgetProposal))
        return (
            <div className="page-container">
                <Loading />
            </div>
        );

    return (
        <CurrentBudgetProposalContext.Provider value={budgetProposal}>
            {children}
        </CurrentBudgetProposalContext.Provider>
    );
};

export default CurrentBudgetProposalProvider;
